import { useState, useEffect, RefObject } from 'react';

export const usePageScroll = (scrollRef?: RefObject<HTMLElement>) => {
	const [scrollPercentage, setScrollPercentage] = useState(0);

	const handleScroll = () => {
		const element = scrollRef?.current;
		let percentage = 0;

		if (element) {
			const { scrollTop, scrollHeight, clientHeight } = element;
			const height = scrollHeight - clientHeight;

			if (height > 0) {
				percentage = (scrollTop / height) * 100;
			}
		} else {
			const scrollTop = window.scrollY || document.documentElement.scrollTop;
			const scrollHeight =
				document.documentElement.scrollHeight - document.documentElement.clientHeight;

			if (scrollHeight > 0) {
				percentage = (scrollTop / scrollHeight) * 100;
			}
		}

		setScrollPercentage(percentage);
	};

	useEffect(() => {
		const target = scrollRef?.current;
		const listener = target || window;

		listener.addEventListener('scroll', handleScroll, { passive: true });

		return () => {
			listener.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return scrollPercentage;
};
